import { useState } from 'react';

interface IProps {
  defaultIsOpen?: boolean;
}

export const useAccordion = ({ defaultIsOpen }: IProps) => {
  const [isOpen, setOpen] = useState(defaultIsOpen ?? false);

  const onToggle = () => {
    setOpen(prevState => !prevState);
  };

  return {
    isOpen,
    setOpen,
    onToggle,
  };
};

export type IUseAccordionType = ReturnType<typeof useAccordion>;
